import {Injectable} from '@angular/core';
import {
  THINGS_LIST_TABS,
  TRASH,
  RECYCLE,
  RESTROOM_FEMALE,
  RESTROOM_MALE,
  TIME_BASED_TASK,
  THING_TYPES_TO_ICON,
  SUPPLY,
  CART_BANANA_BOAT,
  DUMPSTER,
  THING_TYPES_TO_LABELS,
  DEFAULT_CANS_THRESHOLD,
  DEFAULT_TIME_BASED_THRESHOLD} from '../constants/things.constants';
import { ThingConfig } from '@core/thing/thingConfig';

@Injectable()
export class ThingsUtil {

  constructor() {}

  isCan(thing) {
    return thing.type === TRASH || thing.type === RECYCLE;
  }

  isRestroom(thing) {
    return thing.type === RESTROOM_FEMALE || thing.type === RESTROOM_MALE;
  }

  isTimeBasedTask(thing) {
    return thing.type === TIME_BASED_TASK;
  }

  isResource(thing) {
    return thing.type === SUPPLY || thing.type === CART_BANANA_BOAT || thing.type === DUMPSTER;
  }

  isActive(thing): boolean {
    if (this.isCan(thing)) {
      return thing.deactivated ? !thing.deactivated : true;
    } else if (this.isRestroom(thing)) {
      return thing.closed ? !thing.closed : true;
    } else {
      return false;
    }
  }

  getConfig(thing): any {
    let thingType = thing && thing.type,
      tabName;

    if (this.isCan(thing)) {
      tabName = 'cans';
    } else if (this.isRestroom(thing)) {
      tabName = 'restrooms';
    } else if (this.isTimeBasedTask(thing)) {
      tabName = 'time-based';
    } else if (this.isResource(thing)) {
      tabName = 'resources';
    }

    return this.getConfigByTabName(tabName);
  }

  getConfigByTabName(tabName): ThingConfig {
    return THINGS_LIST_TABS.find(tab => tab.name === tabName) as ThingConfig;
  }

  getIcon(thing): string {
    let thingType = thing && thing.type;


    if (thingType) {
      return THING_TYPES_TO_ICON[thingType];
    }
  }

  getLabelForType(type): string {
    return THING_TYPES_TO_LABELS[type];
  }

  getDefaultThreshold(thingType:string): number {
    if (thingType === 'can') {
      return DEFAULT_CANS_THRESHOLD;
    }

    return DEFAULT_TIME_BASED_THRESHOLD;
  }
}



// WEBPACK FOOTER //
// D:/dclean-web-latest/task/cot-web/src/app/util/things.ts